import { render, staticRenderFns } from "./serviceImage.vue?vue&type=template&id=735b515a&scoped=true&"
import script from "./serviceImage.vue?vue&type=script&lang=js&"
export * from "./serviceImage.vue?vue&type=script&lang=js&"
import style0 from "./serviceImage.vue?vue&type=style&index=0&id=735b515a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735b515a",
  null
  
)

export default component.exports